import React from 'react';

interface DividerProps {
  spacing?: string;
}

const Divider: React.FC<DividerProps> = ({ spacing = '20px' }) => {
  return (
    <div style={{
      height: '1px',
      background: 'linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.15), transparent)',
      margin: `${spacing} 0`,
    }} />
  );
};

export default Divider;
